export const LightColors = {
    bg: '#111111',
    surface: '#1c1c1c',
    surfaceRaised: '#272727',
    surfaceSunken: '#161616',
    border: '#2e2a24',
    borderStrong: '#3a3530',
    text: '#f5f0e8',
    textMuted: '#9a9080',
    textFaint: '#5a5248',
    textInverse: '#111111',
    accent: '#c9a84c',
    accentHover: '#b8960c',
    accentSubtle: '#7a5c1e',
    accentText: '#f5f0e8',
    success: '#4ADE80',
    successSubtle: '#0D2818',
    warning: '#FBBF24',
    warningSubtle: '#271B07',
    danger: '#F87171',
    dangerSubtle: '#2A0E0E',
    info: '#60A5FA',
    infoSubtle: '#0C1A35',
    statusWatched: '#4ADE80',
    statusWatching: '#60A5FA',
    statusWants: '#A78BFA',
};
export const DarkColors = {
    bg: '#111111',
    surface: '#1c1c1c',
    surfaceRaised: '#272727',
    surfaceSunken: '#161616',
    border: '#2e2a24',
    borderStrong: '#3a3530',
    text: '#f5f0e8',
    textMuted: '#9a9080',
    textFaint: '#5a5248',
    textInverse: '#111111',
    accent: '#c9a84c',
    accentHover: '#b8960c',
    accentSubtle: '#7a5c1e',
    accentText: '#f5f0e8',
    success: '#4ADE80',
    successSubtle: '#0D2818',
    warning: '#FBBF24',
    warningSubtle: '#271B07',
    danger: '#F87171',
    dangerSubtle: '#2A0E0E',
    info: '#60A5FA',
    infoSubtle: '#0C1A35',
    statusWatched: '#4ADE80',
    statusWatching: '#60A5FA',
    statusWants: '#A78BFA',
};
export function getColors(dark) {
    return dark ? DarkColors : LightColors;
}
export const FontSize = {
    xs: 11, sm: 12, base: 14, md: 16, lg: 18, xl: 22, '2xl': 28, '3xl': 36,
};
export const FontWeight = {
    light: '300', regular: '400', medium: '500',
};
export const Space = {
    1: 4, 2: 8, 3: 12, 4: 16, 5: 20, 6: 24, 8: 32, 10: 40, 12: 48, 16: 64,
};
export const Radius = {
    sm: 2, md: 4, lg: 6, xl: 10, full: 9999,
};
export const Duration = {
    fast: 80, base: 150, slow: 250,
};
export const ZIndex = {
    dropdown: 100, sticky: 200, overlay: 300, modal: 400, toast: 500,
};
export const WatchStatusLabel = {
    watched: 'Watched',
    watching: 'Watching',
    wants_to_watch: 'Want to Watch',
};
const statusColorMap = {
    watched: { light: LightColors.statusWatched, dark: DarkColors.statusWatched },
    watching: { light: LightColors.statusWatching, dark: DarkColors.statusWatching },
    wants_to_watch: { light: LightColors.statusWants, dark: DarkColors.statusWants },
};
export function watchStatusColor(status, dark) {
    if (!status)
        return dark ? DarkColors.textMuted : LightColors.textMuted;
    const entry = statusColorMap[status];
    return dark ? entry.dark : entry.light;
}
